module.exports = "/static/assets/40bdb123f50c303bc8471cf1b50e52a5.png";